import React from 'react';
import RecentTripCard from './RecentTripCard';
import { Compass } from 'lucide-react';

const RecentTripsGrid = ({ trips }) => {
  if (!trips || trips.length === 0) {
    return (
      <div className="py-20 flex flex-col items-center justify-center text-center bg-gray-50 rounded-3xl border border-gray-100 border-dashed">
        <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mb-4 text-gray-400">
          <Compass size={32} />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">No trips yet</h3>
        <p className="text-gray-500 max-w-sm">
          This traveler hasn't published any trips yet. Check back later!
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {trips.map((trip, idx) => (
        <RecentTripCard key={trip.id || trip.slug || idx} trip={trip} />
      ))}
    </div>
  );
};

export default RecentTripsGrid;
